import MapOutlinedIcon from '@material-ui/icons/MapOutlined';

import List from './List';

export default {
  list: List,
  icon: MapOutlinedIcon,
};
